import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { JourneyViewActivityDetailsSidebarComponent } from './Components/journey-view-activity-details-sidebar/journey-view-activity-details-sidebar.component';
import { JourneyViewActivityComponent } from './Components/journey-view-activity/journey-view-activity.component';
import { JourneyViewLearningLevelComponent } from './Components/journey-view-learning-level/journey-view-learning-level.component';
import { AppRoutingModule } from './app-routing.module';


import { ActivitiesListingBodyComponent } from './Components/activities-listing-body/activities-listing-body.component';
import { AppComponent } from './Components/app/app.component';
import { HeaderBatchComponent } from './Components/batch-selector-tool/header-batch/header-batch.component';
import { HeaderComponent } from './Components/header/header.component';
import { ActivityListService } from './Services/activity-list.service';
import { HttpClientService } from './Services/http-client.service';
import { JourneyMilestoneService } from './Services/journey-milestone.service';
import { SessionService } from './Services/session.service';
import { UserService } from './Services/user.service';
import { CustomerIoService } from './Services/customer-io.service';
import { RudderStackService } from './Services/rudderstack.service';
import { EventService } from './Services/event.service';

import { CommonModule, DatePipe } from "@angular/common";
import { DataTableModule } from "angular2-datatable";
import { ImageUploadModule } from "angular2-image-upload";
import { MyDatePickerModule } from 'mydatepicker';
import { ClickOutsideModule } from 'ng-click-outside';
import { ArchwizardModule } from 'angular-archwizard';
import { ChartsModule } from 'ng2-charts';
import { IonRangeSliderModule } from "ng2-ion-range-slider";
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AccountInfoComponent } from './Components/account-info/account-info.component';
import { ActivityAttemptsComponent } from './Components/activity-attempts/activity-attempts.component';
import { ActivityDetailsBodyForumViewComponent } from './Components/activity-details-body-forum-view/activity-details-body-forum-view.component';
import { ActivityDetailsBodyComponent } from './Components/activity-details-body/activity-details-body.component';
import { ActivityDetailsSidebarComponent } from './Components/activity-details-sidebar/activity-details-sidebar.component';
import { ActivityDetailsComponent } from './Components/activity-details/activity-details.component';
import { ActivityForumsSidebarComponent } from './Components/activity-forums-sidebar/activity-forums-sidebar.component';
import { ActivityListViewComponent } from './Components/activity-list-view/activity-list-view.component';
import { ActivityListComponent } from './Components/activity-list/activity-list.component';
import { AdobeRedirectNewComponent } from './Components/adobe-redirect-new/adobe-redirect-new.component';
import { AdobeRedirectComponent } from './Components/adobe-redirect/adobe-redirect.component';
import { ArchivedActivityDetailsBodyComponent } from './Components/archived-activity-details-body/archived-activity-details-body.component';
import { BatchSelectorComponent } from './Components/batch-selector-tool/batch-selector/batch-selector.component';
import { ComponentWithHeaderBatchComponent } from './Components/batch-selector-tool/component-with-header-batch/component-with-header-batch.component';
import { BookmarksComponent } from './Components/bookmarks/bookmarks.component';
import { ChangePasswordComponent } from './Components/change-password/change-password.component';
import { ComponentWithHeaderComponent } from './Components/component-with-header/component-with-header.component';
import { ExtendCourseSubscriptionComponent } from './Components/extend-course-subscription/extend-course-subscription.component';
import { extendCourseComponent } from './Components/extend-course/extend-course.component';
import { ExtensionTermsComponent } from './Components/extension-terms/extension-terms.component';
import { ForgotPasswordComponent } from './Components/forgot-password/forgot-password.component';
import { ForumPostComponent } from './Components/forum-post/forum-post.component';
import { ForumsExpertComponent } from './Components/forums-expert/forums-expert.component';
import { ForumsUserComponent } from './Components/forums-user/forums-user.component';
import { GettingStartedComponent } from './Components/getting-started/getting-started.component';
import { JourneyViewComponent } from './Components/journey-view/journey-view.component';
import { LearningLevelDetailsComponent } from './Components/learning-level-details/learning-level-details.component';
import { LearningLevelComponent } from './Components/learning-level/learning-level.component';
import { LiveSessionPurchaseModalComponent } from './Components/live-session-purchase-modal/live-session-purchase-modal.component';
import { LiveSessionsInfoComponent } from './Components/live-sessions-info/live-sessions-info.component';
import { LockedActivityPopupComponent } from './Components/locked-activity-popup/locked-activity-popup.component';
import { MarketingMessageComponent } from './Components/marketing-message/marketing-message.component';
import { SidePanelCardsComponent } from './Components/side-panel-cards/side-panel-cards.component';
import { SidePanelPreviewComponent } from './Components/side-panel-preview/side-panel-preview.component';
import { NotesComponent } from './Components/notes/notes.component';
import { PaymentScreenComponent } from './Components/payment-screen/payment-screen.component';
import { PersonalizedStudyPlannerComponent } from './Components/personalized-study-planner/personalized-study-planner.component';
import { PurchasesComponent } from './Components/purchases/purchases.component';
import { RecentActivityBodyComponent } from './Components/recent-activity-body/recent-activity-body.component';
import { RequestOverloadComponent } from './Components/request-overload-page/request-overload-page.component';
import { ResetSuccessComponent } from './Components/reset-success/reset-success.component';
import { StatsDashboardComponent } from './Components/stats-dashboard/stats-dashboard.component';
import { UserInfoHeaderComponent } from './Components/user-info-header/user-info-header.component';
import { UserNotesComponent } from './Components/user-notes/user-notes.component';
import { EditMenuHoverDirective } from './Directives/edit-menu-hover.directive';
import { AddOrdinalInDatePipe } from './Pipes/add-ordinal-in-date.pipe';
import { CamelCasePipe } from './Pipes/camel-case.pipe';
import { CharacterLimitSanitizePipe } from './Pipes/character-limit-sanitize.pipe';
import { CharactersLimitPipe } from './Pipes/characters-limit.pipe';
import { DataFilterPipe } from './Pipes/data-filter.pipe';
import { DateOrdinalSuffixPipe } from './Pipes/date-ordinal-suffix.pipe';
import { EvenOddFilterPipe } from './Pipes/even-odd-filter.pipe';
import { FirstLetterPipe } from './Pipes/first-letter.pipe';
import { FirstNamePipe } from './Pipes/first-name.pipe';
import { FormatDatePipe } from './Pipes/format-date.pipe';
import { FormatTimePipe } from './Pipes/format-time.pipe';
import { HiddenFilterPipe } from './Pipes/hidden-filter.pipe';
import { Highlight } from './Pipes/highlight.pipe';
import { ReplaceSpaceWithDashPipe } from './Pipes/replace-space-with-dash.pipe';
import { RoundoffPipe } from './Pipes/roundoff.pipe';
import { SearchFilterPipe } from './Pipes/search-filter.pipe';
import { StatusFilterPipe } from './Pipes/status-filter.pipe';
import { StripHTMLTagsPipe } from './Pipes/strip-htmltags.pipe';
import { TitleCasePipe } from './Pipes/title-case.pipe';
import { TwoDigitsConverterPipe } from './Pipes/two-digits-converter.pipe';
import { AdminGuardService } from './Services/admin-guard.service';
import { PasswordService } from './Services/password.service';

import { HttpClientModule } from '@angular/common/http';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgCircleProgressModule } from "ng-circle-progress";
import { MultipleActivitySessionPopup } from './Components/multiple-activity-session-popup/multiple-activity-session-popup';
import { PostRegistrationSplashPopupComponent } from './Components/post-registration-splash-popup/post-registration-splash-popup.component';
import { FormatHoursInDaysPipe } from './Pipes/format-hours-in-days.pipe';
import { FormatMinutesHoursPipe } from './Pipes/format-minutes-hours.pipe';
import { FormatMinutesSecondsPipe } from './Pipes/format-minutes-seconds.pipe';
import { RangePipe } from './Pipes/range.pipe';
import { CommonUtilityModule } from './modules/common-utility/common-utility.module';
import { CementingLearningLevelComponent } from './Components/cementing-learning-level/cementing-learning-level.component';
import { CementingPanelComponent } from './Components/cementing-panel/cementing-panel.component';
import { CementingStatusService } from './Services/cementing-status.service';
import { CementingStatusMockInterceptor } from './Services/cementing-status-mock.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RemoveUnderScorePipe } from './Pipes/remove-under-score.pipe';
import { CalendarWeekViewComponent } from './Components/calendar-week-view/calendar-week-view.component';
import { SuccessCompassDataService } from './Services/success-campass.service';
import { CalendarActivityComponent } from './Components/calendar-activity/calendar-activity.component';
import { CalendarWeekSkeletonViewComponent } from './Components/calendar-week-skeleton-view/calendar-week-skeleton-view.component';
import { ActivityPspInfoComponent } from './Components/activity-psp-info/activity-psp-info.component';
import { PspNoPlanViewComponent } from './Components/psp-no-plan-view/psp-no-plan-view.component';
import { RecentActivityGraphComponent } from './Components/recent-activity-graph/recent-activity-graph.component';
import { ActivityPspInfoNoPlanComponent } from './Components/activity-psp-info-no-plan/activity-psp-info-no-plan.component';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { SafeHtmlPipe } from './Pipes/safe-html.pipe';
import { DashboardTimeTrackingComponent } from './Components/dashboard-time-tracking/dashboard-time-tracking.component';
import { GraphTimeTrackingHighchartComponent } from './Components/graph-time-tracking-highchart/graph-time-tracking-highchart.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { ProgressDashboardComponent } from './Components/dashboard-time-spent/progress-dashboard/progress-dashboard.component';
import { CircularProgressComponent } from './Components/dashboard-time-spent/circular-progress/circular-progress.component';
import { StreakCardComponent } from './Components/dashboard-time-spent/streak-card/streak-card.component';
import { StripedCircleComponent } from './Components/dashboard-time-spent/striped-circle/striped-circle.component';
import { StreakMessageService } from './Services/streak-message.service';
import { PopupComponent } from './Components/popup/popup.component';
import { HeaderLmsComponent } from './Components/header-lms/header-lms.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HeaderBatchComponent,
    ActivitiesListingBodyComponent,
    StatsDashboardComponent,
    CamelCasePipe,
    ActivityDetailsBodyComponent,
    ActivityListComponent,
    ReplaceSpaceWithDashPipe,
    RecentActivityBodyComponent,
    JourneyViewComponent,
    LearningLevelComponent,
    JourneyViewLearningLevelComponent,
    LearningLevelDetailsComponent,
    ActivityListViewComponent,
    ActivityAttemptsComponent,
    DashboardTimeTrackingComponent,
    SearchFilterPipe,
    StatusFilterPipe,
    ActivityDetailsComponent,
    ActivityDetailsSidebarComponent,
    JourneyViewActivityDetailsSidebarComponent,
    JourneyViewActivityComponent,
    MarketingMessageComponent,
    SidePanelCardsComponent,
    SidePanelPreviewComponent,
    ComponentWithHeaderComponent,
    LiveSessionsInfoComponent,
    LiveSessionPurchaseModalComponent,
    TwoDigitsConverterPipe,
    FirstNamePipe,
    RoundoffPipe,
    EditMenuHoverDirective,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    ResetSuccessComponent,
    UserInfoHeaderComponent,
    AccountInfoComponent,
    TitleCasePipe,
    AddOrdinalInDatePipe,
    BookmarksComponent,
    DataFilterPipe,
    ForumPostComponent,
    NotesComponent,
    CharactersLimitPipe,
    ActivityForumsSidebarComponent,
    ForumsUserComponent,
    FirstLetterPipe,
    ForumsExpertComponent,
    ActivityDetailsBodyForumViewComponent,
    UserNotesComponent,
    CharacterLimitSanitizePipe,
    DateOrdinalSuffixPipe,
    StripHTMLTagsPipe,
    LockedActivityPopupComponent,
    AdobeRedirectComponent,
    AdobeRedirectNewComponent,
    PurchasesComponent,
    extendCourseComponent,
    GettingStartedComponent,
    Highlight,
    PersonalizedStudyPlannerComponent,
    ComponentWithHeaderBatchComponent,
    BatchSelectorComponent,
    FormatDatePipe,
    EvenOddFilterPipe,
    FormatTimePipe,
    RequestOverloadComponent,
    ExtensionTermsComponent,
    ExtendCourseSubscriptionComponent,
    ArchivedActivityDetailsBodyComponent,
    PaymentScreenComponent,
    HiddenFilterPipe,
    FormatMinutesHoursPipe,
    FormatHoursInDaysPipe,
    FormatMinutesSecondsPipe,
    RangePipe,
    MultipleActivitySessionPopup,
    PostRegistrationSplashPopupComponent,
    CementingLearningLevelComponent,
    CementingPanelComponent,
    RemoveUnderScorePipe,
    CalendarWeekViewComponent,
    CalendarActivityComponent,
    CalendarWeekSkeletonViewComponent,
    ActivityPspInfoComponent,
    PspNoPlanViewComponent,
    RecentActivityGraphComponent,
    ActivityPspInfoNoPlanComponent,
    SafeHtmlPipe,
    GraphTimeTrackingHighchartComponent,
    ProgressDashboardComponent,
    CircularProgressComponent,
    StreakCardComponent,
    StripedCircleComponent,
    PopupComponent,
    HeaderLmsComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ClickOutsideModule,
    HttpClientModule,
    BsDropdownModule.forRoot(),
    AlertModule.forRoot(),
    PopoverModule.forRoot(),
    AppRoutingModule,
    ChartsModule,
    ReactiveFormsModule,
    MyDatePickerModule,
    DataTableModule,
    HighchartsChartModule,
    BrowserAnimationsModule,
    CKEditorModule,
    IonRangeSliderModule,
    ImageUploadModule.forRoot(),
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 100,
      outerStrokeWidth: 8,
      outerStrokeLinecap: "butt",
      innerStrokeWidth: 8,
      space: -10,
      maxPercent: 100,
      showSubtitle: false,
      titleFontSize: "20",
      unitsFontSize: "20",
      titleColor: "#404040",
      unitsColor: "#404040",
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
    }),
    CommonUtilityModule,
    ModalModule.forRoot(),
    //DragulaModule
    ArchwizardModule
  ],
  providers: [
    HttpClientService,
    SessionService,
    StreakMessageService,
    JourneyMilestoneService,
    CementingStatusService,
    // dev-only: serves mock cementing status when localStorage.cementingMock is set (no-op in prod builds)
    { provide: HTTP_INTERCEPTORS, useClass: CementingStatusMockInterceptor, multi: true },
    ActivityListService,
    UserService,
    PasswordService,
    DatePipe,
    Highlight,
    AdminGuardService /*DragulaService*/,
    BsModalService,
    SuccessCompassDataService,
    CustomerIoService,
    RudderStackService,
    EventService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
